import { enGB } from 'date-fns/locale';
import merge from 'lodash/merge';
import action from './action.js';
import enActivity from './activity.js';
import core from './core.js';
import error from './error.js';
import login from './login.js';

var en = {
  language: 'en',
  country: 'gb',
  name: 'English',
  embeddedLocale: merge(action, enActivity, core, error, login),
  flags: ['GB', 'US'],
  dateFns: enGB,
  format: {
    date: 'd.MM.yyyy',
    dateTime: '$t(format:date) $t(format:time)',
    time: 'HH:mm',
  },
};

export { en as default };
